<div class="applicant-step1-compliance">
  <h3 class="section-title mb-3">{{ 'fundApplication.complianceSectionTitle' | translate }}</h3>

  <div [formGroup]="form" class="compliance-form">
    <div class="yes-no-block">
      <div class="yes-no-question" id="apply-q-sao">{{ 'authorizedPerson.sameAsOwner' | translate }}</div>
      <div class="yes-no-buttons" role="radiogroup" [attr.aria-labelledby]="'apply-q-sao'">
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="sameAsOwner"
            value="yes"
            id="apply-sao-y"
            [disabled]="isDetails"
          />
          <label
            for="apply-sao-y"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('sameAsOwner')?.value !== 'yes'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.yes' | translate }}
          </label>
        </span>
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="sameAsOwner"
            value="no"
            id="apply-sao-n"
            [disabled]="isDetails"
          />
          <label
            for="apply-sao-n"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('sameAsOwner')?.value !== 'no'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.no' | translate }}
          </label>
        </span>
      </div>
      <small *ngIf="form.get('sameAsOwner')?.touched && form.get('sameAsOwner')?.hasError('required')" class="p-error">
        {{ 'validation.required' | translate }}
      </small>
    </div>

    <div class="yes-no-block">
      <div class="yes-no-question" id="apply-q-pe">{{ 'authorizedPerson.politicalExposed' | translate }}</div>
      <div class="yes-no-buttons" role="radiogroup" [attr.aria-labelledby]="'apply-q-pe'">
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="politicalExposed"
            value="yes"
            id="apply-pe-y"
            [disabled]="isDetails"
          />
          <label
            for="apply-pe-y"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('politicalExposed')?.value !== 'yes'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.yes' | translate }}
          </label>
        </span>
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="politicalExposed"
            value="no"
            id="apply-pe-n"
            [disabled]="isDetails"
          />
          <label
            for="apply-pe-n"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('politicalExposed')?.value !== 'no'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.no' | translate }}
          </label>
        </span>
      </div>
      <small *ngIf="form.get('politicalExposed')?.touched && form.get('politicalExposed')?.hasError('required')" class="p-error">
        {{ 'validation.required' | translate }}
      </small>
    </div>

    <div class="yes-no-block">
      <div class="yes-no-question" id="apply-q-us">{{ 'fundApplication.usCitizenQuestion' | translate }}</div>
      <div class="yes-no-buttons" role="radiogroup" [attr.aria-labelledby]="'apply-q-us'">
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="usCitizenBoardOrSeniorManagement"
            value="yes"
            id="apply-us-y"
            [disabled]="isDetails"
          />
          <label
            for="apply-us-y"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('usCitizenBoardOrSeniorManagement')?.value !== 'yes'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.yes' | translate }}
          </label>
        </span>
        <span class="yes-no-pair">
          <input
            type="radio"
            class="yes-no-input"
            formControlName="usCitizenBoardOrSeniorManagement"
            value="no"
            id="apply-us-n"
            [disabled]="isDetails"
          />
          <label
            for="apply-us-n"
            class="yes-no-label p-button p-component"
            [class.p-button-outlined]="form.get('usCitizenBoardOrSeniorManagement')?.value !== 'no'"
            [class.p-disabled]="isDetails"
          >
            {{ 'common.no' | translate }}
          </label>
        </span>
      </div>
      <small
        *ngIf="form.get('usCitizenBoardOrSeniorManagement')?.touched && form.get('usCitizenBoardOrSeniorManagement')?.hasError('required')"
        class="p-error"
      >
        {{ 'validation.required' | translate }}
      </small>
    </div>

    <div class="agency-file-section mt-4">
      <h3 class="section-title mb-3">{{ 'fundApplication.agencyLetterSectionTitle' | translate }}</h3>
      <div class="field file-field">
        <label for="letter"
          >{{ 'authorizedPerson.letter' | translate }}
          <span *ngIf="!isDetails" class="text-500 font-normal">({{ 'fundApplication.optional' | translate }})</span></label
        >

        <ng-container *ngIf="!isDetails">
          <div class="upload-card">
            <div class="upload-toolbar">
              <p-fileUpload
                #fileUploader
                mode="basic"
                name="agencyLetter"
                accept=".pdf,.jpg,.jpeg,.png"
                [chooseLabel]="'authorizedPerson.chooseFile' | translate"
                (onSelect)="onFileUpload($event)"
                [auto]="true"
                [disabled]="isUploading || isDeleting"
              ></p-fileUpload>
              <small class="upload-hint">{{ 'fundApplication.uploadHintPdfImage' | translate }}</small>
            </div>

            <div *ngIf="isUploading" class="upload-status">
              <i class="pi pi-spin pi-spinner mr-2"></i>
              {{ 'fundApplication.uploadingFile' | translate }}
            </div>

            <div *ngIf="uploadErrorMessage" class="upload-error mt-2">
              <i class="pi pi-exclamation-triangle mr-2"></i>
              {{ uploadErrorMessage | translate }}
            </div>

            <div *ngIf="selectedFileName" class="uploaded-file-card mt-3">
              <div class="uploaded-file-left">
                <i class="pi pi-file file-icon"></i>
                <div class="file-meta">
                  <small class="text-500">{{ 'fundApplication.fileReady' | translate }}</small>
                </div>
              </div>
              <div class="uploaded-file-actions">
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="pi pi-eye"
                  [label]="'common.view' | translate"
                  (click)="previewUploadedFile()"
                  [disabled]="!hasStoredAgencyLetter && !uploadedFileUrl && !form.get('authorizationDocumentFileUrl')?.value"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm p-button-danger"
                  icon="pi pi-trash"
                  [label]="'common.delete' | translate"
                  (click)="deleteUploadedFile()"
                  [disabled]="isDeleting"
                ></button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isDetails">
          <div *ngIf="hasStoredAgencyLetter || agencyLetterPublicDownloadUrl" class="mt-2">
            <button
              pButton
              type="button"
              icon="pi pi-download"
              class="p-button-outlined"
              [label]="'CompanyDocument.clickToDownload' | translate"
              (click)="openAgencyLetterDownload()"
            ></button>
          </div>
          <div
            *ngIf="!hasStoredAgencyLetter && !agencyLetterPublicDownloadUrl"
            class="compliance-doc-missing mt-2"
          >
            {{ 'fundApplication.agencyLetterNotUploaded' | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
